import "core-js/stable";
import "regenerator-runtime/runtime";
import "isomorphic-fetch";
import 'nodelist-foreach-polyfill';
import React from 'react';
import PropTypes from 'prop-types';
import render from '@rmb185/react-renderhelper';
import CustomLazyLoad from '../components/CustomLazyLoad';

const containers = document.querySelectorAll('[data-component-type]');


class ModuleLoader extends React.Component {

  static defaultProps = {
    moduleName: PropTypes.string,
    config: PropTypes.object,
  }

  state = {
    module: null,
    isnewDesignPage : false
  }

  componentDidMount = () => {

    let endpoint = window.location.pathname.split('/').filter(Boolean).pop();

    
    if (endpoint=='products' || endpoint=='benchtop-spectrophotometers') {
      import("../../../src/scss/components/GenericBanner/BannerNew");
      import("../../../src/scss/components/GenericTextArea");
      import("../../../src/scss/components/Products/AllProductsNew");
    }else{
      import("../../../src/scss/components/GenericBanner/Banner");
    }

    if(endpoint=='colorflex-l2' || (endpoint=='colorflex-l2-tomato') || (endpoint === 'colorflex-l2-citrus')){
      import("../../../src/scss/components/Products/ProductHeroNew");
      import("../../../src/scss/components/Products/SpecificationsNew");
      import("../../../src/scss/components/Products/ProductIntroNew");
      import("../../../src/scss/components/GenericCarouselNew");
    }

    if(endpoint!='colorflex-l2' && endpoint!='colorflex-l2-tomato' && endpoint!='colorflex-l2-tomato' && endpoint!='colorflex-l2-citrus' && endpoint!='products' && window.location.pathname.includes('products')){
      import("../../../src/scss/components/Products/ProductHero");
      import("../../../src/scss/components/Products/Specifications");
      import("../../../src/scss/components/Products/ProductIntro");
      
    }

    import(`js/components/${this.props.moduleName}`).then((Module) => {

      if (/(127\.0\.0\.1)|(localhost)/.test(window.location.hostname)) {
      }
      this.setState({
        module: <Module.default {...this.props.config} />,
      })
    }).catch((err) => {
      console.trace(err, this.props.moduleName);
    })

    const newDesignPageEndpoints = ['colorflex-l2', 'colorflex-l2-tomato', 'colorflex-l2-citrus', 'products', 'benchtop-spectrophotometers'];


    if(!newDesignPageEndpoints.includes(endpoint)){
      // console.log("applying new sccs style in default.js");
      import("../../../src/scss/components/GlobalHeaders")
    }
  }
  render() {
    return this.state.module ? this.state.module : <div/>;
  }
}

function getModuleName(moduleName) {
  if (/SiteSearch/.test(moduleName)) {
    moduleName = "Search/" + moduleName;
  }
  if (/IntroHero|LeftAlignedHero|CenteredCard|LeftAlignedCard|LeftAlignedPrefooter|CenteredPrefooter/.test(moduleName)) {
    moduleName = "GenericBanner/" + moduleName;
  }
  if (/ProductHero|AllProductsSpanish|AllProductsUKEnglish|ProductIntro|Features|AllProducts|ProductCarousel|Specifications/.test(moduleName)) {
    moduleName = "Products/" + moduleName;
  }
  if (/Applications|ApplicationsSpanish|ApplicationsUKEnglish|Accessories|ApplicationCategorySelector|ApplicationCategorySelectorSpanish|ApplicationCategorySelectorUKEnglish|ApplicationCategoryList|ApplicationCategoryListSpanish|ApplicationCategoryListUKEnglish|ApplicationSummary|ApplicationSummarySpanish|ApplicationSummaryUKEnglish/.test(moduleName)) {
    moduleName = "Applications/" + moduleName;
  }
  if (/FAQs|ContactCards|ContactForm|ContactFormSpanish/.test(moduleName)) {
    moduleName = "Contact/" + moduleName;
  }
  return moduleName;
}

function isLazyLoadRequired(moduleName, index) {
  if (/(Footer)/.test(moduleName))
    return false;
  var currentPage = document.querySelector('body');
  if (currentPage.classList.contains("productdetail") || currentPage.classList.contains("mission"))
    return false;//ignore lazy load for product detail page -- Fix for GitHub#378
  return index > 3;//ignore lazy load for first three components - Fix for GitHub#198
}
function trackClickPath() {
  var clickPath = sessionStorage.getItem("ClickPath");
  const document_referrer = sessionStorage.getItem('document_referrer');
  
  if (document_referrer === null || document_referrer === undefined || document_referrer.includes('hunterlab')) {
    sessionStorage.removeItem('document_referrer');
    sessionStorage.setItem('document_referrer', document.referrer);
  }


  if (clickPath) {
    clickPath += '\n' + window.location.href
  }
  else
    clickPath = '\n' + window.location.href;
  sessionStorage.setItem('ClickPath', clickPath);
}

trackClickPath();

containers.forEach((el, i) => {
  let config = {},
    clsName = el.dataset.componentType;

  config = el.dataset.config || '{}';
  let isLazyLoad = isLazyLoadRequired(clsName, i);
  config = JSON.parse(config);
  clsName = getModuleName(clsName);
  if (isLazyLoad) {
    render(
      <>
      {/* <CustomLazyLoad height={500}> */}
        <ModuleLoader config={config} moduleName={clsName} />
      {/* </CustomLazyLoad>, */}
      </>,
      el
    );
  } else {
    if (/Footer/.test(clsName)) {
      //merge main navigation config object with footer
      var ctrlFooter = document.querySelector('[data-component-type="MainNavigation"]')
      let mainNavConfig = ctrlFooter.dataset.config || '{}';
      mainNavConfig = JSON.parse(mainNavConfig);
      config = { ...mainNavConfig, ...config }
    }
    render(<ModuleLoader config={config} moduleName={clsName} />, el);
  }

});
